/** Banner stylesheet. Kept free of DOM types so the dashboard can import it for the static preview. */
export const CSS = `
:host{all:initial}
*{box-sizing:border-box}
.wrap{position:fixed;z-index:2147483646;font-family:var(--font);color:var(--text);font-size:15px;line-height:1.45}
.wrap.bottom{left:16px;right:16px;bottom:16px;display:flex;justify-content:center}
.wrap.bottom-left{left:16px;bottom:16px;max-width:400px}
.wrap.bottom-right{right:16px;bottom:16px;max-width:400px}
.wrap.center{inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.4)}
.card{background:var(--bg);border-radius:var(--radius);box-shadow:0 8px 32px rgba(0,0,0,.16);padding:18px 20px;max-width:560px;width:100%;outline:none;max-height:calc(100vh - 32px);overflow:auto;display:flex;flex-wrap:wrap;align-items:center;row-gap:8px;column-gap:12px}
h2{flex:0 0 100%;font-size:16px;line-height:1.3;margin:0;font-weight:600}
p{flex:0 0 100%;margin:0;font-size:14.5px;color:var(--muted)}
.row{display:flex;flex-wrap:wrap;gap:8px;align-items:center;flex:1 1 auto;margin-top:4px}
button{font:inherit;font-weight:600;font-size:13.5px;border-radius:calc(var(--radius) - 4px);padding:9px 14px;cursor:pointer;border:0;background:color-mix(in srgb,var(--text) 9%,transparent);color:var(--text);min-height:40px;min-width:40px}
button.primary{background:var(--primary);color:var(--on-primary)}
button.text{border:0;background:none;color:var(--muted);text-decoration:underline;padding:9px 6px;font-weight:500}
button:focus-visible{outline:3px solid #2563eb;outline-offset:2px}
.links{flex:0 0 auto;margin:4px 0 0;font-size:12.5px;display:flex;flex-wrap:wrap;gap:4px 12px}
.links a{color:var(--muted)}
.links a.pb{opacity:.75}
.notice p{color:var(--text)}
.cat{flex:0 0 100%;display:flex;gap:12px;align-items:flex-start;padding:9px 0;border-top:1px solid rgba(0,0,0,.08)}
.cat:first-of-type{border-top:0}
.cat label{flex:1;cursor:pointer}
.cat strong{display:block;font-size:14px}
.cat span{font-size:12.5px;color:var(--muted)}
.cat input{width:22px;height:22px;margin-top:2px;accent-color:var(--primary)}
.always{font-size:12px;color:var(--muted);white-space:nowrap;margin-top:4px}
.badge{position:fixed;left:16px;bottom:16px;z-index:2147483645;font-family:var(--font);background:var(--primary);color:var(--on-primary);border-radius:999px;box-shadow:0 4px 16px rgba(0,0,0,.2)}
.gpc{flex:0 0 100%;margin:0;font-size:13px;font-weight:600;color:var(--text)}
.toast{position:fixed;left:16px;bottom:16px;z-index:2147483645;font-family:var(--font);font-size:13.5px;font-weight:600;background:var(--bg);color:var(--text);border-radius:calc(var(--radius) - 4px);padding:10px 14px;box-shadow:0 4px 16px rgba(0,0,0,.18);transition:opacity .5s}
.toast.out{opacity:0}
.hidden{display:none!important}
@media (max-width:480px){.wrap.bottom,.wrap.bottom-left,.wrap.bottom-right{left:8px;right:8px;bottom:8px;max-width:none}.card{padding:16px}.wrap.l1 .card{max-height:40vh}}
@media (pointer:coarse){button{min-height:44px;min-width:44px}}
@media (prefers-reduced-motion:no-preference){.card{animation:in .18s ease-out}}
@keyframes in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
`;
